import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import api from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import Nav from "@/components/Nav";
import SEO from "@/components/SEO";
import JsonLd, { articleSchema } from "@/components/JsonLd";
import Footer from "@/components/Footer";
import WhatsappFAB from "@/components/WhatsappFAB";

export default function InsightDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/insights/${slug}`).then((r) => setPost(r.data)).catch((e) => setErr(e?.response?.status || "err"));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white">
      {post && <SEO title={post.title} description={post.excerpt} image={post.cover_image_url} />}
      {post && <JsonLd data={articleSchema(post, typeof window !== "undefined" ? window.location.origin : "")} />}
      <Nav />
      <main className="pt-28 md:pt-36 pb-20">
        <div className="container-x max-w-3xl">
          <Link to="/#insights" data-testid="insight-back" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-neutral-500 hover:text-[color:var(--brand)] transition-colors">
            <ArrowLeft size={14} weight="bold" /> All insights
          </Link>
          {err && <div className="mt-10 text-neutral-500">Post not found.</div>}
          {post && (
            <article data-testid="insight-article" className="mt-8">
              <div className="flex flex-wrap gap-2 mb-4">
                {(post.tags || []).map((t) => (
                  <span key={t} className="font-mono text-[10px] uppercase tracking-widest border border-[color:var(--line)] px-2 py-1 text-neutral-600">{t}</span>
                ))}
              </div>
              <h1 className="font-display font-black text-4xl md:text-5xl leading-[1.05] tracking-tighter">{post.title}</h1>
              <div className="mt-3 font-mono text-xs uppercase tracking-widest text-neutral-500">
                {post.author} · {String(post.created_at || "").slice(0, 10)}
              </div>
              {post.cover_image_url && (
                <div className="mt-8 border border-[color:var(--line)]">
                  <img src={post.cover_image_url} alt={post.title} className="w-full" />
                </div>
              )}
              <div className="prose-md mt-10 text-neutral-800">
                <ReactMarkdown>{post.body_md}</ReactMarkdown>
              </div>
            </article>
          )}
        </div>
      </main>
      <Footer />
      <WhatsappFAB />
    </div>
  );
}
